const componentStyles = (theme) => ({
  header: {
    background:
      "linear-gradient(87deg," + theme.palette.info.main + ",#1171ef)",
  },
});

export default componentStyles;
